import _ from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trimmedStringsAreDifferent = function (first: any, second: any) {
  return !_.eq(_.trim(_.toString(first)), _.trim(_.toString(second)));
};

export const maybeAppend = function (a: string | null, b: string | null): string | null {
  if (a !== null && b !== null) {
    return a + b;
  } else {
    return null;
  }
};

export const removeWhitespace = (value: string) => value.replace(/\s+/g, '');

export const camelCaseToTitleCase = (str: string) =>
  str
    .toLowerCase()
    .replace(/(^\w)/g, (g) => g[0].toUpperCase())
    .replace(/([-_]\w)/g, (g) => ' ' + g[1].toUpperCase())
    .trim();

export const makeSentenceCase = (str: string) => {
  const s = str.trim();
  if (!s.length) {
    return '';
  }
  const firstChar = s.charAt(0).toUpperCase();
  const rest = s
    .substring(1)
    .toLowerCase()
    .replace(/([-_.]\w)/g, (g) => ' ' + g[1])
    .trim();
  return `${firstChar}${rest}`;
};
